/**
 * NavButton Component
 * Individual button for FloatingNavBar
 */

import React from 'react';
import { Tooltip } from 'antd';

interface NavButtonProps {
  /** Icon to display */
  icon: React.ReactNode;
  /** Button label */
  label: string;
  /** Active state */
  active?: boolean;
  /** Click handler */
  onClick: () => void;
  /** Tooltip text (optional, defaults to label) */
  tooltip?: string;
}

export const NavButton: React.FC<NavButtonProps> = ({
  icon,
  label,
  active = false,
  onClick,
  tooltip,
}) => {
  return (
    <Tooltip title={tooltip || label} placement="top">
      <button
        className={`nav-button ${active ? 'nav-button-active' : ''}`}
        onClick={onClick}
        aria-label={label}
        aria-pressed={active}
      >
        <span className="nav-button-icon">{icon}</span>
        <span className="nav-button-label">{label}</span>
      </button>
    </Tooltip>
  );
};
